import { render, staticRenderFns } from "./AutoScroll.vue?vue&type=template&id=2c61ea09&scoped=true&"
import script from "./AutoScroll.vue?vue&type=script&lang=js&"
export * from "./AutoScroll.vue?vue&type=script&lang=js&"
import style0 from "./AutoScroll.vue?vue&type=style&index=0&id=2c61ea09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c61ea09",
  null
  
)

export default component.exports